/* tslint:disable */
/* eslint-disable */
/**
 * Zamna Ready To Fly API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.18
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum PaxCheckChecklistResolutionStatus {
    READY_TO_FLY = 'READY_TO_FLY',
    ENTRY_NOT_ALLOWED = 'ENTRY_NOT_ALLOWED',
    ACTION_REQUIRED = 'ACTION_REQUIRED',
    UNKNOWN = 'UNKNOWN',
    NOT_ELIGIBLE = 'NOT_ELIGIBLE'
}


export function instanceOfPaxCheckChecklistResolutionStatus(value: any): boolean {
    for (const key in PaxCheckChecklistResolutionStatus) {
        if (Object.prototype.hasOwnProperty.call(PaxCheckChecklistResolutionStatus, key)) {
            if (PaxCheckChecklistResolutionStatus[key as keyof typeof PaxCheckChecklistResolutionStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PaxCheckChecklistResolutionStatusFromJSON(json: any): PaxCheckChecklistResolutionStatus {
    return PaxCheckChecklistResolutionStatusFromJSONTyped(json, false);
}

export function PaxCheckChecklistResolutionStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaxCheckChecklistResolutionStatus {
    return json as PaxCheckChecklistResolutionStatus;
}

export function PaxCheckChecklistResolutionStatusToJSON(value?: PaxCheckChecklistResolutionStatus | null): any {
    return value as any;
}

export function PaxCheckChecklistResolutionStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): PaxCheckChecklistResolutionStatus {
    return value as PaxCheckChecklistResolutionStatus;
}

